// extracted by mini-css-extract-plugin
export default {"mainContainer":"myfavorite_mainContainer__JVNKN","heading":"myfavorite_heading__BL3EQ","circleGroup":"myfavorite_circleGroup__vkoiY"};